class HoverImageText {
  constructor(tile) {
    this.tile = tile;
    this.tileOverlay = this.tile.querySelector('.tile-overlay');
    this.itemTitle = this.tileOverlay.querySelector('.item-title');
    this.itemText = this.tileOverlay.querySelector('.item-summary');
    this.extraPadding = 25;
    this.timeout = null;
  }

  init() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
    this.tile.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.tile.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  handleMouseEnter() {
    if (window.innerWidth >= 768) {
      this.setExposedAllTextOffset();
    }
  }

  handleMouseLeave() {
    if (window.innerWidth >= 768) {
      this.setExposedTitleOffset();
    }
  }

  handleResize() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (window.innerWidth < 768) {
        this.setExposedAllTextOffset();
      } else {
        this.setExposedTitleOffset();
      }
    }, 50);
  }

  setExposedAllTextOffset() {
    const offset = this.itemTitle.offsetHeight + this.itemText.offsetHeight + (this.extraPadding * 1.5);
    this.tileOverlay.style.transform = `translateY(-${offset}px)`
  }

  setExposedTitleOffset() {
    const offset = this.itemTitle.offsetHeight + this.extraPadding;
    this.tileOverlay.style.transform = `translateY(-${offset}px)`;
  }
}

export default HoverImageText;